/** Back to top button */
export function initBackToTop(): void {
  document.querySelector('.bttb')?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    document.getElementById('bttb')?.classList.remove('active')
  })
}
